export default __webpack_public_path__ + "static/media/element_18.29e7d305.jpg";